import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { UserState } from "../types/inspections/UserState";
import { AppThunk, RootState } from "../redux/store";
import {
    getUserCapabilities,
    GetUserCapabilitiesRequestData,
    getUserInfo,
    GetUserInfoRequestData
} from "../services/user";
import { getOrganisationsInfoAsync } from "../services/InspectionsServices";
import { getUserToken } from "../services/UserService";

const initialState: UserState = {
    UserServiceInfo: undefined,
    AmplifyUser: undefined,
    UserInfoStatus: "idle",
    Capabilities: [],
    UserCapabilityStatus: "idle",
    SelectedGroupName: "",
    OrganisationsInfo: [],
    OrganisationsInfoStatus: "idle",
    UserToken: undefined
};

export const userSlice = createSlice({
    name: "userSlice",
    initialState,
    reducers: {
        setSelectedGroupName: (state, action: PayloadAction<string>) => {
            state.SelectedGroupName = action.payload;
        },
        setUserToken: (state, action: PayloadAction<string | undefined>) => {
            state.UserToken = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUserInfoThunk.fulfilled, (state, action) => {
                state.UserServiceInfo = action.payload;
                state.UserInfoStatus = "succeeded";
            })
            .addCase(getUserInfoThunk.pending, (state, _action) => {
                state.UserInfoStatus = "pending";
            })
            .addCase(getUserInfoThunk.rejected, (state, _action) => {
                state.UserInfoStatus = "failed";
            })
            .addCase(getUserCapabilitiesThunk.fulfilled, (state, action) => {
                state.Capabilities = action.payload;
                state.UserCapabilityStatus = "succeeded";
            })
            .addCase(getUserCapabilitiesThunk.pending, (state, _action) => {
                state.UserCapabilityStatus = "pending";
            })
            .addCase(getUserCapabilitiesThunk.rejected, (state, _action) => {
                state.UserCapabilityStatus = "failed";
            })
            .addCase(getUserOrganisationsInfoThunk.fulfilled, (state, action) => {
                state.OrganisationsInfo = action.payload;
                state.OrganisationsInfoStatus = "succeeded";
            })
            .addCase(getUserOrganisationsInfoThunk.pending, (state, _action) => {
                state.OrganisationsInfoStatus = "pending";
            })
            .addCase(getUserOrganisationsInfoThunk.rejected, (state, _action) => {
                state.OrganisationsInfoStatus = "failed";
            });
    }
});

export const getUserInfoThunk = createAsyncThunk(
    "user/getUserInfo",
    async (requestData: GetUserInfoRequestData) => getUserInfo(requestData.userId)
);

export const getUserCapabilitiesThunk = createAsyncThunk(
    "user/getUserCapabilities",
    async (requestData: GetUserCapabilitiesRequestData) => getUserCapabilities(requestData.userId)
);

export const getUserOrganisationsInfoThunk = createAsyncThunk(
    "user/getUserOrganisationsInfo",
    async (orgIds: string[]) => getOrganisationsInfoAsync(orgIds)
);

export const fetchUserToken =
    (): AppThunk => async (dispatch) => {
        try {
            const response = await getUserToken();

            if (response) {
                dispatch(setUserToken(response));
            } else {
                throw Error("no data");
            }
        } catch (e) {
            console.error(e);
        }
    };


export const userSliceSelector = (state: RootState) => state.User;
export const { setSelectedGroupName, setUserToken } = userSlice.actions;

export default userSlice.reducer;
